export enum EventType {
	CLICK = 'click',
	CLOSE = 'close',
	VIEW = 'view',
}
